export const employeesList = [
  "John Heart",
  "Samantha Bright",
  "Arthur Miller",
  "Robert Reagan",
  "Greta Sims",
  "Brett Wade",
  "Sandra Johnson",
  "Ed Holmes",
  "Barb Banks",
  "Kevin Carter",
  "Cindy Stanwick",
  "Sammy Hill",
  "Davey Jones",
  "Victor Norris",
  "Mary Stern",
  "Robin Cosworth",
  "Kelly Rodriguez",
  "James Anderson",
  "Antony Remmen",
  "Olivia Peyton",
  "Taylor Riley",
  "Amelia Harper",
  "Wally Hobbs",
  "Brad Jameson",
  "Karen Goodson",
  "Marcus Orbison",
  "Sandy Bright",
  "Morgan Kennedy",
  "Violet Bailey",
  "Ken Samuelson",
  "Nat Maguiree",
  "Bart Arnaz",
  "Leah Simpson",
  "Arnie Schwartz",
  "Billy Zimmer",
  "Samantha Piper",
  "Maggie Boxter",
  "Terry Bradley",
  "Gabe Jones",
  "Lucy Ball",
  "Jim Packard",
  "Hannah Brookly",
  "Harv Mudd",
  "Clark Morgan",
  "Todd Hoffman",
  "Jackie Garmin",
  "Lincoln Bartlett",
  "Brad Farkus",
  "Jenny Hobbs",
  "Dallas Lou",
  "Stu Pizaro",
];

export const employeesTasks = [
  {
    ID: 3,
    name: "Аж ахуй нэгж байгууллага",
    role: "user",
    Subject: "Choose between PPO and HMO Health Plan",
  },
  {
    ID: 4,
    name: "Админ",
    role: "admin",
    Subject: "Google AdWords Strategy",
  },
  {
    ID: 5,
    name: "super",
    role: "Супер админ",
    Subject: "New Brochures",
  },
];
